import React from "react";
import { Helmet } from "react-helmet";

const page = [
  { pathName: "beslenme", pageName: "Beslenme" },
  function () {
    return (
      <div className="subPages_hizmetlerimiz-defaultCard">
        <Helmet>
          <title>Kampüs Kreş - Beslenme</title>
          <meta name="title" content="Kampüs Kreş - Beslenme" />
          <meta property="og:title" content="Kampüs Kreş - Beslenme" />
          <meta name="twitter:title" content="Kampüs Kreş - Beslenme" />

          <meta
            name="keywords"
            content="kreş yemek listesi, yemek listesi, kampüs kreş yemek listesi"
          />
        </Helmet>
        <div className="subPages_hizmetlerimiz-defaultCard_firstColumn">
          <div className="iframe">
            <a href="/assets/yemek_listesi.pdf" className="iframe_placeholder">
              Yemek Listesi
            </a>
            <div>
              <iframe
                title="Kampüs Kreş Yemek Listesi"
                scrolling="no"
                src={`https://docs.google.com/gview?url=${process.env.REACT_APP_HOST}/assets/yemek_listesi.pdf&embedded=true`}
              />
            </div>
          </div>
          <p className="iframe_warning">
            yemek listemizi yüksek çözünürlükte görüntülemek için üstüne
            tıklayınız
          </p>
        </div>
        <div className="subPages_hizmetlerimiz-defaultCard_secondColumn">
          <p>
            <strong>Kampüs Kreş’te</strong>, öğrencilerimizin sağlıklı ve
            dengeli beslenmeleri amacıyla yemeklerimiz, profesyonel bir ekip
            eşliğinde kendi mutfağımızda özenle hazırlanmaktadır.{" "}
            <strong>Anaokulu</strong> ve <strong>kreş</strong> düzeyindeki
            çocuklarımızın yaş gruplarına uygun şekilde planlanan bu menüler,
            onların <strong>çocuk gelişimi</strong> ihtiyaçlarına göre
            düzenlenmektedir. Mutfağımızda 1 aşçı, 1 pastacı, 1 aşçı yamağı, 2
            yemekhane personeli ve 1 bulaşıkçı görev yapmaktadır.
            <br />
            <br />
            <strong>Okul öncesi</strong> eğitim sürecinde beslenme
            alışkanlıklarının kazanılması büyük önem taşımaktadır. Bu bilinçle,
            kahvaltı, öğle yemeği ve ikindi kahvaltısı olmak üzere çocuklarımıza
            günde üç öğün yemek servisi sunulmaktadır. Tüm ürünlerimiz günlük
            olarak taze şekilde tüketilmekte olup, ürün siparişleri haftalık
            olarak planlanmakta ve kontrol edilmektedir.
            <br />
            <br />
            Yemeklerde hazır meyve suları veya paketli hazır gıdalar kesinlikle
            kullanılmamaktadır. Öğünlerimiz, porselen tabaklarda ve ev
            sıcaklığındaki sunum anlayışıyla çocuklara servis edilmekte, onların
            yemek saatlerini keyifli ve sağlıklı hale getirmeyi amaçlamaktayız.
            <strong>Kampüs Kreş</strong> olarak bu konuda titizliğimizi her
            ayrıntıya yansıtarak, çocuklarımızın <strong>çocuk gelişimi</strong>{" "}
            açısından sağlıklı beslenme alışkanlıkları kazanmalarını
            destekliyoruz.
            <br />
            <br />
            Ayrıca, bebek grubundaki öğrencilerimiz için özel olarak hazırlanan
            meyve püresi, yoğurt gibi ek besinler de yine mutfağımızda günlük
            olarak üretilmekte ve hijyenik koşullarda sunulmaktadır.{" "}
            <strong>Kreş</strong>
            seviyesindeki öğrencilerimizin hassas ihtiyaçları gözetilerek,
            hijyen ve beslenme standartlarımız sürekli olarak güncellenmektedir.
            <br />
            <br />
          </p>
        </div>
      </div>
    );
  },
];

export default page;
